<template>
  <div class="container homebase-container pt-5 pb-5">
    <div class="pb-4">
      <div><back-to-home-button /></div>
    </div>
    <div><h1>Bookmarks</h1></div>
    <loading-overlay v-if="isLoading" />
    <div v-else>
      <div class="row">
        <div class="col-12 ">
            <div v-if="successMessage" class="fade-in-out alert alert-success px-2 ml-2">
              <div class="ml-1 d-inline justify-content-start">{{successMessage}}</div>
                <div class="d-inline justify-content-end">
                    <div class="close close-icon pr-2" >
                        <font-awesome-icon icon="times" size="xs" class="close-icon" @click="close"/>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="alert alert-error" v-if="isErrored">
        {{ CONSTANTS.SERVER_ERROR_MESSAGE }}
      </div>
      <div v-else>
        <div class="table-wrapper mt-5">
          <vue-good-table
            :columns="columns"
            :rows="formattedRows"
            class="table-word-wrap"
            :search-options="searchOptions"
            :pagination-options="{
              enabled: this.paginationEnabled,
              ...paginationOptions,
            }"
            styleClass="vgt-table striped"
          >
            <div slot="emptystate">
              <div class="emptystate-text">No bookmarks to display</div>
            </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'actions'">
                <div class="content row-content">
                  <a
                    :href="props.row.url"
                    :target="getBookmarkTarget(props.row.url)"
                    class="d-inline view-url"
                    rel="noopener noreferrer"
                    @click="handleViewClick(props.row)"
                  >
                    View
                  </a>
                </div>
              </span>
              <span v-else-if="props.column.field == 'title'">
                <div >
                <AutodeskOneToggleBookmarkPage :bookmarkRowValue="props.row" class="mr-2" @update="onUpdateMessage($event)"/>
                <span>
                  {{ props.row.title }}
                </span>
                </div>
              </span>
            </template>
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.label == 'Actions'"
                >{{ props.column.label }}
              </span>
              <span v-else-if="props.column.label === 'Bookmark name'">
                {{ props.column.label }}
              </span>
              <span v-else>
                {{ props.column.label }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";
import { VueGoodTable } from "vue-good-table";
import { mapGetters,mapActions } from "vuex";

import LoadingOverlay from "@/components/LoadingOverlay";
import AutodeskOneBookmarksMixin from "@/mixins/AutodeskOneBookmarksMixin";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import BackToHomeButton from "@/components/homebase/buttons/BackToHomeButton";
import AutodeskOneToggleBookmarkPage from "@/components/homebase/pages/AutodeskOneToggleBookmarkPage";

export default {
  name: "autodesk-one-bookmarks-page",
  mixins: [HomebaseMixpanelMixin, AutodeskOneBookmarksMixin],
  components: {
    LoadingOverlay,
    VueGoodTable,
    BackToHomeButton,
    AutodeskOneToggleBookmarkPage,
  },
  data() {
    return {
      CONSTANTS,
      isLoading: false,
      isErrored: false,
      isBookmarked: false,
      bookmark: {},
      // search
      searchOptions: {
        enabled: true,
        skipDiacritics: true,
        placeholder: "Search bookmarks",
      },
      // pagination
      paginationOptions: {
        mode: "records",
        perPage: CONSTANTS.PAGINATION_THRESHOLD,
        position: "bottom",
        perPageDropdown: [10, 25, 50],
        dropdownAllowAll: true,
        nextLabel: "next",
        prevLabel: "prev",
        rowsPerPageLabel: "Rows per page",
        ofLabel: "of",
        pageLabel: "page", // for 'pages' mode
        allLabel: "All",
      },
      // columns
      columns: [
        {
          label: "Bookmark name",
          field: "title",
          type: "string",
          thClass: "width-sm",
          tdClass: "align-left truncate",
          width: "36%",
        },
        {
          label: "Link",
          field: "url",
          type: "string",
          thClass: "hide-field-sm",
          tdClass: "hide-field-sm truncate",
          width: "44%",
        },
        {
          label: "Date added",
          type: "string",
          field(rowObj) {
            if (rowObj.dateAdded) {
              return rowObj.dateAdded.substring(0, 10);
            }
          },
          thClass: "width-sm hide-date-responsive",
          tdClass: "hide-date-responsive",
          width: "12%",
        },
        {
          label: "Actions",
          field: "actions",
          thClass: "th-actions text-nowrap",
          tdClass: "td-actions text-nowrap",
          width: "8%",
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.initializeBookmarks();
    this.trackAutodeskOnePageHit("Bookmarks");
  },
  computed: {
    ...mapGetters(["successMessage","errorMessage","user"]),
    paginationEnabled() {
      return (
        this.bookmarks && this.bookmarks.length > CONSTANTS.PAGINATION_THRESHOLD
      );
    },
    formattedRows() {
      return this.bookmarks;
    },
    isTableEmpty() {
      return !this.bookmarks || this.bookmarks.length == 0;
    },
  },
  methods: {
    ...mapActions['setBannerSuccessMessage','setBannerErrorMessage'],
    close() {
        this.$store.dispatch('setBannerSuccessMessage','')
    },
    onUpdateMessage(message) {
                message.messageType == 'Success' ? this.$store.dispatch('setBannerSuccessMessage',message.messageText) : this.$store.dispatch('setBannerErrorMessage',message.messageText);
            },
    async initializeBookmarks() {
      this.isLoading = true;
      try {
        
        let res = await this.getAllBookmarks();
        let bookmarks = this.filterBookmarks(res);
        this.bookmarks = bookmarks;
      } catch (e) {
        this.isErrored = true;
      } finally {
        this.isLoading = false;
      }
    },
    handleViewClick(bookmarkData) {
      let title = bookmarkData.title;
      let url = bookmarkData.url;
      let subEvent = `${title} - ${url}`;
      this.trackViewBookmark(subEvent);
    },
  },
};
</script>

<style scoped src="../../../../static/aone-theme.css"></style>
<style scoped src="../../../../static/vgt-styles.css"></style>
<style scoped>
a {
  font-family: artifaktElementBold;
}
a:hover {
  cursor: pointer;
  text-decoration: none !important;
}
.homebase-container {
  min-height: 800px;
}
.bookmark-icon {
  font-size: 20px;
  color: #2bc275 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/homebase/pages/AutodeskOneBookmarksPage.vue